import { render, staticRenderFns } from "./ModalFormAmountComponent.vue?vue&type=template&id=4f0d82b9&scoped=true"
import script from "./ModalFormAmountComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormAmountComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalFormAmountComponent.vue?vue&type=style&index=0&id=4f0d82b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d82b9",
  null
  
)

export default component.exports